import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { AuthGuard } from '../../services/auth-guard.service';
import { LoadingModule } from '../shared/controls/loading.component';
import { NotesModule } from '../shared/controls/notes.component';
import { LastUpdatedModule } from '../shared/controls/last-updated.component';

import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { SortIconCustomModule } from '../shared/controls/dynamic/sort-icon-custom.component';
import { OrderListComponent } from './order-list.component';
import { OrdersComponent } from './orders.component';
import { DynamicValueModule } from '../shared/controls/dynamic/dynamic-value.component';
import { OrderDetailComponent } from './order-detail.component';
import { VehiclesDetailModule } from '../shared/controls/vehicles-detail.component';
import { PaginatorCustomModule } from '../shared/controls/dynamic/paginator-custom.component';
import { OrderFormModule } from './order-form.component';
import { ModalLeftNavModule } from '../shared/controls/dynamic/modal-left-nav.component';
import { VehiclesFormModule } from '../shared/controls/vehicles-form.component';
import { UploadsModule } from '../shared/controls/uploads.component';
import { CheckboxModule } from 'primeng/checkbox';
import { KeyFilterModule } from 'primeng/keyfilter';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { UserFormModule } from '../users/user-form.component';
import { RowToolsModule } from '../shared/controls/row-tools.component';
import { NotesDetailModule } from '../shared/controls/notes-detail.component';
import { OrderTagsModule } from './order-tags.component';
import { ContactsDetailModule } from '../shared/controls/contacts-detail.component';
import { LocationFormModule } from '../locations/location-form.component';
import { CalendarModule } from 'primeng/calendar';
import { DynamicBulkUploadModule } from '../shared/controls/dynamic-bulk-upload.component';
import { DriverTruckOverhualFormModule } from '../shared/controls/driver-truck-overhual-form.componet';
import { ConfirmDeleteDialogModule } from '../shared/controls/confirm-delete-dialog.component';




@NgModule({
  declarations: [
    OrdersComponent,
    OrderListComponent,
    OrderDetailComponent,
  ],
  imports: [
    CommonModule,
    TableModule,
    DialogModule,
    LoadingModule,
    ButtonModule,
    LastUpdatedModule,
    SortIconCustomModule,
    DynamicValueModule,
    VehiclesDetailModule,
    PaginatorCustomModule,
    ModalLeftNavModule,
    VehiclesFormModule,
    NotesModule,
    NotesDetailModule,
    UploadsModule,
    CheckboxModule,
    KeyFilterModule,
    ConfirmDialogModule,
    OrderFormModule,
    UserFormModule,
    RowToolsModule,
    OrderTagsModule,
    ContactsDetailModule,
    LocationFormModule,
    CalendarModule,
    DynamicBulkUploadModule,
    DriverTruckOverhualFormModule,
    ConfirmDeleteDialogModule,
    RouterModule.forChild([
      {
        path: '',
        component: OrdersComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', component: OrderListComponent, canActivate: [AuthGuard] },
        ]
      }
    ])
  ],
  exports: [
    OrdersComponent,
    OrderListComponent,
    OrderDetailComponent,
  ]
})
export class OrdersModule { }

